import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, Input } from '../../../GlobalUI';

function GoogleAnalyticsForm({
  onChangeGoogleTagManagerId,
  enabled,
  gtmTrackingId,
  onToggle,
}) {
  return (
    <div className="setup-config-section">
      <div className="setup-config-header">Google Tag Manager</div>
      <div className="setup-config-content">
        <b>Enable Google Tag Manager </b>
        <Toggle value={enabled} onToggle={onToggle} />
        {enabled && (
          <Input
            label="Tracking ID*"
            value={gtmTrackingId}
            onChange={onChangeGoogleTagManagerId}
          />
        )}
      </div>
    </div>
  );
}

GoogleAnalyticsForm.propTypes = {
  enabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onChangeGoogleTagManagerId: PropTypes.func,
  gtmTrackingId: PropTypes.string,
};

export default GoogleAnalyticsForm;
